import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Container, Row} from "@pg-design/grid-module";
import {useModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";

import {PriceTransparencyModal} from "../../offer/components/PriceTransparencyModal";

export const HomepagePriceTransparencyBanner = () => {
    const {
        modalProps: {isOpen},
        closeModal,
        openModal
    } = useModal();

    const handleOpenModal = () => {
        openModal();
    };

    return (
        <Container as="section" fluid className={containerStyle}>
            <Row className={rowStyle}>
                <Text strong align="center" as="div" variant="headline_6" className={textStyle}>
                    Ceny wszystkich mieszkań są już jawne
                </Text>

                <Button className={buttonStyle} size="x-small" variant="outlined_secondary" onClick={handleOpenModal}>
                    Zobacz, co to oznacza
                </Button>

                <PriceTransparencyModal isOpen={isOpen} closeModal={closeModal} />
            </Row>
        </Container>
    );
};

const containerStyle = css({
    backgroundColor: "var(--colors-primary)",
    display: "flex",
    justifyContent: "center",
    paddingX: 3
});

const rowStyle = css({
    alignItems: "center",
    flexDirection: "column",
    rowGap: 1,
    paddingY: 1.5,

    md: {
        paddingY: 2,
        columnGap: 3,
        flexDirection: "row"
    }
});

const textStyle = css({
    paddingY: 1
});

const buttonStyle = css({
    minWidth: "28rem",
    "& span": {
        textTransform: "none",
        fontWeight: 500
    }
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Container, Row} from "@pg-design/grid-module";
import {useModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";

import {PriceTransparencyModal} from "../../offer/components/PriceTransparencyModal";

export const HomepagePriceTransparencyBanner = () => {
    const {
        modalProps: {isOpen},
        closeModal,
        openModal
    } = useModal();

    const handleOpenModal = () => {
        openModal();
    };

    return (
        <Container as="section" fluid className={containerStyle}>
            <Row className={rowStyle}>
                <Text strong align="center" as="div" variant="headline_6" className={textStyle}>
                    Ceny wszystkich mieszkań są już jawne
                </Text>

                <Button className={buttonStyle} size="x-small" variant="outlined_secondary" onClick={handleOpenModal}>
                    Zobacz, co to oznacza
                </Button>

                <PriceTransparencyModal isOpen={isOpen} closeModal={closeModal} />
            </Row>
        </Container>
    );
};

const containerStyle = css({
    backgroundColor: "var(--colors-primary)",
    display: "flex",
    justifyContent: "center",
    paddingX: 3
});

const rowStyle = css({
    alignItems: "center",
    flexDirection: "column",
    rowGap: 1,
    paddingY: 1.5,

    md: {
        paddingY: 2,
        columnGap: 3,
        flexDirection: "row"
    }
});

const textStyle = css({
    paddingY: 1
});

const buttonStyle = css({
    minWidth: "28rem",
    "& span": {
        textTransform: "none",
        fontWeight: 500
    }
});
